export const ONBOARDING_MODALS = {
  FAVORITE_SHELF: 'favoriteShelfOnboarding2025',
  BEAUTY_BOXES: 'beautyBoxesOnboarding2025',
  SHOP: 'shopOnboarding2025',
  PREMIUM: 'premiumOnboarding2025',
  TREE: 'treeOnboarding2025',
};
